var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFilesPreview(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 166,
    height: 166,
    viewBox: "0 0 166 166",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Files_-_preview_icon",
    "data-name": "Files - preview icon",
    transform: "translate(-445 -678.095)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_389",
    "data-name": "Ellipse 389",
    cx: 83,
    cy: 83,
    r: 83,
    transform: "translate(445 678.095)",
    fill: "#004cff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "noun-copy-3029269",
    transform: "translate(491.578 717.587)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_34564",
    "data-name": "Path 34564",
    d: "M59.088,7.212v4.075H29.015A12.636,12.636,0,0,0,16.379,23.923V74.845h-6.7A5.212,5.212,0,0,1,4.47,69.633V7.212A5.212,5.212,0,0,1,9.682,2H53.907A5.212,5.212,0,0,1,59.088,7.212Z",
    transform: "translate(-4.47 -2)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34565",
    "data-name": "Path 34565",
    d: "M58.54,6.94H16.558a6.318,6.318,0,0,0-6.318,6.318V73.467a6.318,6.318,0,0,0,6.318,6.318H58.54a6.318,6.318,0,0,0,6.318-6.318V13.258A6.318,6.318,0,0,0,58.54,6.94Zm-4.833,52.6H21.3a3.159,3.159,0,0,1,0-6.318H53.707a3.159,3.159,0,1,1,0,6.318Zm0-13.015H21.3a3.159,3.159,0,1,1,0-6.318H53.707a3.159,3.159,0,1,1,0,6.318Zm0-13.015H21.3a3.159,3.159,0,0,1,0-6.318H53.707a3.159,3.159,0,1,1,0,6.318Z",
    transform: "translate(7.987 8.665)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilesPreview);
export default __webpack_public_path__ + "static/media/FilesPreview.da91119bc9e6e24e731dfcd551dfff2f.svg";
export { ForwardRef as ReactComponent };